export default __webpack_public_path__ + "static/media/Zimbabwe.79a7554d.png";